import React, { useContext, useEffect, useState } from "react";
import {Form, Button } from "react-bootstrap";
import "./QuanLyHopDong.scss";
import { Formik } from "formik";
import { AppContext } from "../../../../appContext/AppContext";
import FormKetLuan from "./FormKetLuan"
import { QuanLyHopDongContext, QuanLyHopDongContextProps } from "../../tab-quan-ly-hop-dong/QuanLyHopDong"
import { valueStatus } from "../../../constants/PhanHeKhamDoan"
import { formatDateToDDMMYYYY } from "../../../../utils/FormatUtils";
import { PhanHeKhamDoanContext, PhanHeKhamDoanContextProps } from "../../../PhanHeKhamDoan";
import WfButton from "../../../../workflows/components/WfButton";
import { WfConstTracker } from "../../../../workflows/Constant";

type Props = {};

const initialValues: any = {
  examStartDate: "",
  examEndDate: "",
  examStatus: "",
  examConclusion: "",
  neededSolve: "",
  examClassification: "",
};
const TabKetLuan = ({ }: Props) => {
  const { setIsLoading } = useContext(AppContext);
  const { TTNhanVien, isSearchNV, setIsSearchNV } = useContext<QuanLyHopDongContextProps>(QuanLyHopDongContext);
  const { setWorkFlowStatus } = useContext<PhanHeKhamDoanContextProps>(PhanHeKhamDoanContext);
  const [currentWf, setCurrentWf] = useState<any>({})
  const componentName = "TabKetLuan"
  const handlerSave = async (currStatusCode: any, listResponse: any) => {
    setWorkFlowStatus(listResponse?.data?.data);
    setIsSearchNV(!isSearchNV);
  }
  
  const handlerConvert = (values: any) => {
    let day = "";
    if (values?.examEndDate) {
      day = values?.examEndDate
    } else {
      if ([valueStatus.DA_KHAM_XONG, valueStatus.DUYET_BENH_AN].includes(values?.examStatus)) {
        day = formatDateToDDMMYYYY(new Date()) || ""
      } else day = ""
    }
    return day
  }

  return (
    <>
      <Formik initialValues={initialValues} onSubmit={handlerSave}>
        {({
          values,
          setValues,
          handleSubmit,
          setFieldValue,
          errors,
          touched,
          resetForm,
        }) => (
          <Form id="form-Ket-Luan" onSubmit={handleSubmit}>
            <FormKetLuan values={values} setValues={setValues} setFieldValue={setFieldValue} currentWf={currentWf} componentName={componentName}/>
            
            <div className="d-flex flex-end spaces px-12 pb-12 pt-5 gap-10 bg-white">
              <WfButton
                tracker={WfConstTracker?.PHY_EXAM}
                objectId={TTNhanVien?.id}
                additionalProps={
                  {
                    visitId: TTNhanVien?.visitId,
                    examEndDate: handlerConvert(values) || "",
                    ...values
                  }
                }
                additionalFunc={(codeRequest, codeBtn, listResponse) => {
                  handlerSave(codeRequest, listResponse)
                }}
                getCurrentWf={(currentWf: any) => {
                  setFieldValue("status", currentWf?.name)
                  setCurrentWf(currentWf)
                }}
                componentName={componentName}
              ></WfButton>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default TabKetLuan;
